import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EditRosterPropertiesPage } from './edit-roster.page';

const routes: Routes = [
  {
    path: '',
    component: EditRosterPropertiesPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EditRosterPropertiesPageRoutingModule {}
